<template>
  <button
    ref="card"
    class="rounded-lg flex h-[108px] w-[223px]"
    @click="onClick"
  >
    <div class="rounded-lg flex flex-col justify-start gap-0 px-24 py-24 pb-12">
      <DynamicIcon
        class="w-32 h-32"
        :icon="checkpoint.iconToken"
        size="medium"
      />
      <p
        class="text-action-default-hi body-2-bold line-clamp-2 [word-break:break-word] text-ellipsis text-left"
        :title="checkpoint.text"
      >
        {{ checkpoint.text }}
      </p>
    </div>
  </button>
</template>

<script setup lang="ts">
import { onBeforeUnmount, useTemplateRef } from 'vue'

import DynamicIcon from '@backmarket/nuxt-layer-cms/DynamicIcon.vue'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { openModal } from '@ds/components/ModalBase'
import { useIntersectionObserver } from '@vueuse/core'

import type { GetVerifiedRefurbishCarouselResponse } from '~/api/product-page/types'
import { MODAL_NAMES } from '~/scopes/product/constants'

const props = defineProps<{
  checkpoint: GetVerifiedRefurbishCarouselResponse['items'][number]
  index: number
}>()

const { trackClick, trackCarouselImpression } = useTracking()

const card = useTemplateRef<HTMLDivElement>('card')

function onClick() {
  openModal(MODAL_NAMES.VERIFIED_REFURBISHED_CAROUSEL)
  trackClick({
    zone: 'verified_refurbished_carousel',
    value: props.checkpoint.text,
  })
}

const { stop } = useIntersectionObserver(
  card,
  ([{ isIntersecting }]) => {
    if (isIntersecting) {
      trackCarouselImpression({
        name: 'carousel_interaction',
        zone: 'verified_refurbished_carousel',
        blockPosition: props.index,
        currentSlide: props.index,
        value: props.checkpoint.text,
        trackFirstIndex: props.index === 0,
      })
      stop()
    }
  },
  {
    threshold: 0.7,
  },
)

onBeforeUnmount(() => {
  stop()
})
</script>
